import type { ComponentProps } from 'react';
import { cl } from 'utils/classnames';

type SkeletonProps = ComponentProps<'div'>;

export function Skeleton({ className, ...props }: SkeletonProps) {
  return <div className={cl('animate-pulse bg-neutral-inverted/10', className)} {...props} />;
}
